import { MotionConfig } from "motion/react";
import "./index.css";
import { Evolve } from "./sections/Evolve";
import { Goal } from "./sections/Goal";

export function App() {
  return (
    <MotionConfig reducedMotion="user">
      <main>
        <Goal />
        <Evolve />
      </main>
    </MotionConfig>
  );
}

export default App;
